
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gT3Lv", function(module, exports) {
/**
 * Gated entry point for the TWG Explorer section.
 *
 * Guards rendering behind the `cc-ai-twg-visualization` experiment and
 * wraps the lazy-loaded inner content in a `TransparentErrorBoundary`
 * so that failures in the graph section never break the space overview
 * page.
 */ 
var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $hSqtY = parcelRequire("hSqtY");


var $lgZ43 = parcelRequire("lgZ43");


const $f6c80e4b0ee51d27$var$TwgExplorerSectionContent = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kRLv2")).then((mod)=>({
            default: mod.TwgExplorerSectionContent
        })));
function $f6c80e4b0ee51d27$export$c4f05f9024addada({ cloudId: cloudId, spaceId: spaceId, testId: testId }) {
    if (!(0, $6mKj3.expVal)('cc-ai-twg-visualization', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: "twg-explorer-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lgZ43.TwgExplorerSectionLoadingPlaceholder), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6c80e4b0ee51d27$var$TwgExplorerSectionContent, {
        cloudId: cloudId,
        spaceId: spaceId,
        testId: testId
    })));
}
Object.assign($f6c80e4b0ee51d27$export$c4f05f9024addada, {
    displayName: 'TwgExplorerSection'
});
module.exports["TwgExplorerSection"] = $f6c80e4b0ee51d27$export$c4f05f9024addada;

});

parcelRegister("kRLv2", function(module, exports) {

let $f30d9a4d3f1c31fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f30d9a4d3f1c31fd$var$load("h83j5"),
    $f30d9a4d3f1c31fd$var$load("cvcNg"),
    $f30d9a4d3f1c31fd$var$load("6wr18"),
    $f30d9a4d3f1c31fd$var$load("7Wsg9"),
    $f30d9a4d3f1c31fd$var$load("ksZv4"),
    $f30d9a4d3f1c31fd$var$load("1aqfs"),
    $f30d9a4d3f1c31fd$var$load("ffEVr"),
    $f30d9a4d3f1c31fd$var$load("60PUI"),
    $f30d9a4d3f1c31fd$var$load("1xeJ3"),
    $f30d9a4d3f1c31fd$var$load("hBm54")
]).then(()=>parcelRequire('8S2kV'));

});


//# sourceMappingURL=TwgExplorerSection.3e810760.js.map
